export default __webpack_public_path__ + "static/media/raisut-01.64faa5e3.png";